module.exports = __webpack_public_path__ + "static/media/Smart-Message-Web.37173f28.svg";